import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, HostBinding } from '@angular/core';
import { HelpIndex, Endpoint } from '../../../models/enums';
import { GenericColDef, GridContext, CellTemplateType } from '../../../models/grid-context';
import { RestService } from '../../../services/rest/rest.service';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DrRequestInfo } from '../../../models/dr-request-info';
import { CommonService } from '../../../services/common/common.service';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';
import { ObjectActionListType, Permissions } from '../../../models/permission';

@Component({
    standalone: false,
    selector: 'res-live-log-modal',
    templateUrl: './live-log-modal.component.html',
    styleUrls: ['./live-log-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LiveLogModalComponent extends BaseModalComponent implements OnInit {
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(GenericGridComponent) genericGrid: GenericGridComponent;
    @ViewChild('downloadLink', { read: ElementRef, static: true }) downloadLink: ElementRef;

    modalAutomationId = 'live-log-modal';
    modalClass = 'live-log-modal';
    modalTitle = 'Live Log';
    modalHelpIndex = HelpIndex.sys_job_live_log_dlg;
    isBusy = false;
    isBusyMessage = 'Loading Live Log';
    checkboxSelected = {
        INFO: true,
        ERROR: true,
        WARN: true
    }
    numberOfLines: number;
    requestInfo = new DrRequestInfo({
        data: {},
        responseName: 'logLines'
    });
    logs = {
        logLines: [],
        unfilteredLogLines: []
    };
    taskSri: string;

    columnDefs: Array<GenericColDef> = new Array<GenericColDef>(
        {
            headerName: 'Log Entries',
            valueGetter: (params: any) => params.data.replace(/>/g, '&gt;').replace(/</g, '&lt;'),
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            automationId: this.modalAutomationId,
            lockVisible: true,
        }
    );

    gridContext = new GridContext({
    });



    constructor(private restService: RestService, private modalRef: BsModalRef, private modalService: BsModalService, private commonService: CommonService) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.numberOfLines = 1;
        const endpoint = Endpoint.taskManager_getTasks;
        const postParams = {
            taskHandles: [this.modalData.handle],
            includeDrDebug: true,
            includeResourceStatistics: true
        };
        this.restService.post(endpoint, postParams).then(response => {
            if (response?.tasks && response.tasks.length > 0 && response.tasks[0].currentStatus) {
                let tempSRI;
                response.tasks[0].currentStatus.forEach(entry => {
                    entry.data.forEach(attr => {
                        if (attr && attr.name == "SRI") {
                            tempSRI = attr.value;
                            return;
                        }
                    });
                });

                if (tempSRI) {
                    const pieces = tempSRI.split(',');
                    this.taskSri = pieces[pieces.length - 1];
                    this.taskSri = this.taskSri.replace('SRI', '').replace(/\s/g, "").replace(':', '');
                }
            }
            this.loadData();
        });
    }

    loadData() {
        const endpoint = Endpoint.taskManager_getSRITaskLog;
        const postParams = {
            numLines: this.numberOfLines * 1000,
            taskSri: this.taskSri,
        };
        if (this.genericGrid) {
            this.genericGrid.isBusy = true;
        }
        this.restService.post(endpoint, postParams).then(response => {
            this.logs.unfilteredLogLines = [];
            if (response?.logLines) {
                this.logs.unfilteredLogLines = response.logLines;
            }
            this.filterLogsAndLoad();
        });
    }

    loadMore() {
        this.numberOfLines++;
        this.loadData();
    }

    filterLogsAndLoad() {
        this.logs.logLines = [];
        this.logs.unfilteredLogLines.forEach(t => {
            const logParts = t.split(' ');
            if (logParts?.length > 1 && this.checkboxSelected[logParts[2]]) {
                this.logs.logLines.push(t);
            }
        })
        this.gridPagerCustomCallback(0);
    }

    responseCallback = (response: any) => {
        if (this.logs?.logLines) {
            response.numberResults = this.logs.logLines.length;
        }
    }

    gridPagerCustomCallback = (startIndex: any) => {
        if (startIndex !== undefined) {
            const tempLogs = { logLines: [] };
            tempLogs.logLines = this.logs.logLines.slice(startIndex, startIndex + 100);
            this.genericGrid.loadData(startIndex, 100, false, tempLogs);
        }
    }

    closeModal(result?: boolean, data?: any): void {
        this.modalRef.hide();
    }

    downloadLogList(): void {
        const name = 'srilog.txt', typeToUse = 'text/.csv;charset=utf-8';
        const dataResult = this.logs.logLines.join('\r\n');
        const element = this.downloadLink.nativeElement;
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob([dataResult]), name);
        } else {
            const blob = new Blob([dataResult], <BlobPropertyBag>{
                type: typeToUse,
                responseType: 'arraybuffer'
            });

            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, name);
            } else {
                const urlBlob = URL.createObjectURL(blob);
                element.href = urlBlob;
                element.download = name;
                element.target = '_blank';
                element.click();
            }
        }
    }
}
